import { useNavigate } from "react-router-dom"
import { observer } from "mobx-react-lite"
import AuthStore from "../../stores/AuthStore"
import { ProfileIcon, Text } from "../."
import { StyledButton } from "../buttons"
import { Header } from "../other"

export const HomeHeader = observer(() => {
	const navigate = useNavigate()

	return (
		<Header
			right={
				<StyledButton style="flex justify-center items-center w-[40px] h-[40px]" onClick={() => navigate("profile")}>
					<div className="relative">
						<ProfileIcon size={24} />
						{AuthStore.notifications.length > 0 && (
							<div className="absolute bottom-[-5px] right-[-5px] flex h-[16px] w-[16px] items-center justify-center rounded-full bg-[#707070]">
								<Text style="p-0 m-0 leading-[10px] text-[10px] font-bold">
									{AuthStore.notifications.length < 10 ? AuthStore.notifications.length : "9+"}
								</Text>
							</div>
						)}
					</div>
				</StyledButton>
			}
		/>
	)
})
